/**
 * Frontend feature flags.
 */

/**
 * Candidate-facing chat widget and the admin chat surfaces (sidebar entry, notification
 * bell, and the /admin/chat route).
 *
 * Set to false to hide chat from the UI without removing any of it — the components,
 * pages and backend endpoints are all still in place, so flipping this back to true
 * restores the feature with no other changes.
 *
 * Typed as boolean (not the literal false) so the guarded branches stay type-checked.
 */
export const CHAT_ENABLED: boolean = false;
